import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DialogTabs } from "./DialogTabs";

export const OfferReadOnlyView = (props) => {
    const { offer } = props;

    const form = useForm({
        defaultValues: {
            customerIds: [],
            discount: {},
            draftId: undefined,
            expireDate: undefined,
        },
    });

    useEffect(() => {
        if (offer) {
            form.reset({
                // @ts-ignore
                customerIds: offer.customers.map((offerCustomer) => offerCustomer.customer.id),
                discount: Object.fromEntries(
                    offer.products.map((op) => [op.product.id, Number(op.discount_percent)]),
                ),
                // @ts-ignore
                draftId: offer.draft_id || undefined,
                // @ts-ignore
                expireDate: offer.expire_date ? new Date(offer.expire_date) : new Date(),
            });
        }
    }, [offer, form]);

    return (
        <FormProvider {...form}>
            <form>
                <DialogTabs
                    control={form.control}
                    fields={{
                        customerIds: "customerIds",
                        discount: "discount",
                    }}
                    offer={offer}
                    readOnly={true}
                />
            </form>
        </FormProvider>
    );
};
